import React from "react";

export const ServicesLayerContext = React.createContext({});
